import { AxiosError } from 'axios';
import { useState } from 'react';

import { VehicleStatusDataInterface } from '../../../models/dashboard/dashboard/vehicle-status';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { driverTypeDistributionActions } from '../../../redux/slices/driverTypeDistributionStatus';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useDriverTypeDistribution = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onGetDriverTypeDistributionError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onGetDriverTypeDistributionSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<VehicleStatusDataInterface[]>) => {
        dispatch(driverTypeDistributionActions.setDriverTypeDistribution(data));
    };

    const getDriverTypeDistribution = async () => {
        const url: HttpConfig = {
            url: `api/v1/company/driver-status`,
            method: 'get',
        };

        return request(url, onGetDriverTypeDistributionSuccess, setLoading, onGetDriverTypeDistributionError);
    };

    return { getDriverTypeDistribution, loading };
};

export default useDriverTypeDistribution;
